import { BaseNavigationService } from '@shared/utils/navigation';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { BaseHelperComponent } from '../base-helper/base-helper.component';

@Component({
    selector: 'feature-page-layout-page-forbidden',
    templateUrl: './page-forbidden.component.html',
    styleUrls: ['./page-forbidden.component.css'],
    standalone: false
})
export class PageForbiddenComponent extends BaseHelperComponent implements OnInit {
  backUrl = '';
  useDefaultMessage = false;

  private ngUnsubscribe = new Subject<void>();

  constructor(private router: Router, private route: ActivatedRoute, _navigationService: BaseNavigationService) {
    super(_navigationService);
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((params) => {
      const backUrl = params['backUrl'];
      const defaultMsg = params['useDefaultMsg'];
      if (backUrl) {
        this.backUrl = backUrl;
      }
      if (defaultMsg) {
        this.useDefaultMessage = true;
      }
    });
  }

  override navigateBack(): void {
    if (this.backUrl) {
      this.router.navigate([this.backUrl]);
    } else {
      super.navigateBack();
    }
  }
}
